import modalConfig from '../config/modal-config';
const {store, AoflElement, ModalHandler, abcmouseApiService, ServerTime} = aofljs;
/**
 * @summary HomePage
 * @class HomePage
 * @extends {AoflElement}
 */
class HomePage extends AoflElement {
  /**
   * Creates an instance of HomePage.
   * @memberof HomePage
   */
  constructor() {
    super(store);
    new ModalHandler(modalConfig);
    this.pageLoadEventFired = false;
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
    this.mapProperties();
    this.queryParams = new URLSearchParams(window.location.search);
  }

  /**
   *
   * @memberof HomePage
   */
  mapProperties() {
    let state = store.getState().userSession;
    if (!this.pageLoadEventFired && state.pageLoadComplete) {
      this.pageLoadEventFired = true;
      abcmouseApiService.eventLog([{
        url: '@homepage:loadStart',
        page_info_key: 'homepage',
        time: state.pageLoadStart + ServerTime.getDelta('abcmouseMarketing')
      }]);

      if (this.queryParams.get('tid') && this.queryParams.get('tap')) {
        abcmouseApiService.eventLog([{
          url: '@homepage:loadCompleteFull',
          time: state.pageLoadComplete + ServerTime.getDelta('abcmouseMarketing'),
          kvp: {
            tap: this.queryParams.get('tap'),
            tid: this.queryParams.get('tid')
          }
        }]);
      } else {
        abcmouseApiService.eventLog([{
          url: '@homepage:loadCompleteFull',
          time: state.pageLoadComplete + ServerTime.getDelta('abcmouseMarketing')
        }]);
      }
    }
  }

  /**
   *
   * @readonly
   * @static
   * @memberof HomePage
   */
  static get is() {
    return 'home-page';
  }
}

window.customElements.define(HomePage.is, HomePage);



// WEBPACK FOOTER //
// ./home/en-US/js/home-page/home-page.js